import { useEffect, useState } from 'react';
import { Table, Card, Typography, Button, Tooltip, Input } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import EmployeeFundService from '../../../service/employee-service/Employee-fund.service';
import { EmployeeFundWithEmployeeResponse } from '../../../model/EmployeeFund.model';

const { Title } = Typography;

const FundTable = () => {
  const navigate = useNavigate();
  const [funds, setFunds] = useState<EmployeeFundWithEmployeeResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchText, setSearchText] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  useEffect(() => {
    const fetchFundsData = async () => {
      setLoading(true);
      try {
        // 1 request duy nhất — backend đã JOIN employee và lọc admin sẵn
        const fundsWithEmployee = await EmployeeFundService.getAllEmployeeFundWithEmployee();
        setFunds(fundsWithEmployee);
      } catch (error) {
        console.error('Error fetching funds data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFundsData();
  }, []);

  const filteredFunds = funds.filter((fund) => {
    const searchLower = searchText.toLowerCase();
    return (
      fund.employee?.name?.toLowerCase().includes(searchLower) ||
      fund.employee?.user?.username?.toLowerCase().includes(searchLower)
    );
  });

  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) =>
        (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Tên nhân viên',
      dataIndex: ['employee', 'name'],
      key: 'name',
    },
    {
      title: 'Tên tài khoản',
      dataIndex: ['employee', 'user', 'username'],
      key: 'phoneNumber',
    },
    {
      title: 'Vị trí',
      dataIndex: ['employee', 'position'],
      key: 'position',
    },
    {
      title: 'Số dư hiện tại',
      dataIndex: 'currentBalance',
      key: 'currentBalance',
      render: (value: number) => (
        <span>{value.toLocaleString('vi-VN')} VND</span>
      ),
      sorter: (a: EmployeeFundWithEmployeeResponse, b: EmployeeFundWithEmployeeResponse) =>
        a.currentBalance - b.currentBalance,
    },
    {
      title: 'Số giao dịch',
      dataIndex: 'transactions',
      key: 'transactionCount',
      render: (transactions: any[]) => transactions?.length || 0,
      sorter: (a: EmployeeFundWithEmployeeResponse, b: EmployeeFundWithEmployeeResponse) =>
        (a.transactions?.length || 0) - (b.transactions?.length || 0),
    },
    {
      title: 'Cập nhật lần cuối',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (date: string) =>
        date ? new Date(date).toLocaleDateString('vi-VN') : 'N/A',
    },
    {
      title: 'Hành động',
      key: 'action',
      render: (_: any, record: EmployeeFundWithEmployeeResponse) => (
        <Tooltip title="Xem chi tiết">
          <Button
            icon={<EyeOutlined />}
            onClick={() => navigate(`/employee/${record.employee?.id}`)}
            type="link"
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Card>
      <Title level={4}>Bảng Quỹ Nhân Viên</Title>
      <Input.Search
        placeholder="Tìm kiếm theo tên nhân viên hoặc tên tài khoản"
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 16 }}
        allowClear
      />
      <Table
        columns={columns}
        dataSource={filteredFunds.map((fund, index) => ({ ...fund, index }))}
        loading={loading}
        rowKey="id"
        pagination={{
          pageSize: 10,
          current: currentPage,
          onChange: setCurrentPage,
          showSizeChanger: false,
        }}
      />
    </Card>
  );
};

export default FundTable;
